import { render } from "./result.vue?vue&type=template&id=b9ba45da"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=b9ba45da&lang=less"
script.render = render

export default script